import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import VueCurrencyInput from "vue-currency-input";

import moment from "moment";
//Override date format for API calls
Date.prototype.toJSON = function(){ return moment(this).format(); }

/**** Begin Sentry.io Integration ****/
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

Sentry.init({
  dsn: 'https://50df56b799fa4443aed0f62347689ae3@o397620.ingest.sentry.io/5316788',
  integrations: [new VueIntegration({Vue, attachProps: true})],
// eslint-disable-next-line
	environment: ENV,
	beforeSend(event) {
		if (localStorage.getItem("OrderKey") != null) {
			event.tags = event.tags || {};
			event.tags['OrderKey'] = localStorage.getItem("OrderKey");
		}
		return event;
	}
});
/**** End Sentry.io Integration ****/

//let console = {};
//console.log = function() {};
//window.console = console;

// detect and embed custom css if present
function getParameterByName(name) {
  var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
  return match && decodeURIComponent(match[1]);
}
var p = getParameterByName("customcss")
if (p) {
    console.log("Attempting to load custom css from",p)
    let file = document.createElement('link');
    file.rel = 'stylesheet';
    file.href = p
    document.head.appendChild(file)
} else {
  console.log("No custom css detected")
}


const pluginOptions = {
  /* see config reference */
  globalOptions: { currency: "USD", precision: 2, "allow-negative": false }
};
Vue.use(VueCurrencyInput, pluginOptions);

router.beforeEach((to, from, next) => {
  //alert('to: ' + to.path);
  if (to.path.includes("cart")) {
    store.commit("toggleCartLinkActive", true);
  } else {
    store.commit("toggleCartLinkActive", false);
  }
  next();
});

import VueLocalStorage from "vue-localstorage";
Vue.use(VueLocalStorage);

Vue.config.productionTip = false;

// Register a global custom directive called `v-focus`
Vue.directive("focus", {
  // When the bound element is inserted into the DOM...
  inserted: function(el) {
    // Focus the element
    el.focus();
  }
});

// Globally registered components

// Currency $23.98
import Currency from "./components/Currency.vue";
Vue.component("currency", Currency);

// Call To Book
import CallToBook from "./components/CallToBook.vue";
Vue.component("call-to-book", CallToBook);

// Powered by
import PoweredBy from "./components/PoweredBy.vue";
Vue.component("powered-by", PoweredBy);

// Modal
import Modal from "./components/Modal.vue";
Vue.component("modal", Modal);

// toggle UI
import Toggle from "./components/Toggle.vue";
Vue.component("toggle", Toggle);

// page header
import PageHeader from "./components/PageHeader.vue";
Vue.component("page-header", PageHeader);

Vue.use(require("vue-moment"));

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");